// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('💖 yutojp.com 🎉')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
import * as Turbo from '@hotwired/turbo'
Turbo.start()
// import '@hotwired/turbo-rails'
//
// import * as ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

import '../channels'

// Example: Import a stylesheet in app/frontend/index.css

// Entry point for the build script in your package.json
import "../controllers"

// Font Awesome
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

// Fonts
import "@fontsource/nunito";                // 400 normal
import "@fontsource/nunito/500.css";        // 500 normal
import "@fontsource/nunito/700.css";        // 700 normal
import "@fontsource/nunito/400-italic.css"; // 400 italic
import "@fontsource/nunito/700-italic.css"; // 700 italic

// import "@rails/actiontext"
import '../../domains/yuto_cmnt/javascript/index'
import '../src/main'
import '../src/article'

import 'flowbite/dist/flowbite.turbo'
import 'js-toc'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

import '@/builds/tailwind.css'